// eslint-disable-next-line no-restricted-exports
export { DSBanner, DSBannerWithSchema } from './DSBanner.js';
export { DSBannerName, BANNER_TYPES, DSBannerSlots, DSBannerDatatestid } from './exported-related/index.js';
export type { DSBannerT } from './react-desc-prop-types.js';
